import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getDiscountProp() {
    return api.get(`/discounts`);
  },
  updateDiscountProp(payload) {
    return api.put(`/discounts`, { discount_page: payload });
  },
  getDiscount(id) {
    return api.get(`/discounts/${id}`);
  },
  deleteDiscount(id) {
    return api.delete(`/discounts/${id}`);
  },
  updateDiscount(id, payload) {
    return api.put(`/discounts/${id}`, { discount: payload });
  },
  createDiscount(payload) {
    return api.post(`/discounts`, { discount: payload });
  },
  getProductList(
    page,
    q = '',
    sort_by = 'created_at desc',
    limit = '10',
    minPrice,
    maxPrice,
    status
  ) {
    const params = {
      cursor: page,
      limit,
      max_price: maxPrice,
      min_price: minPrice,
      q,
      sort_by,
      status,
    };
    const url = '/discounts/products';
    return api.get(url, { params: omitBy(params, isNil) });
  },
};
